import { useMemo } from "react";
import useCurrentUser from "@/hooks/useCurrentUser";

function isValidIanaTimeZone(timeZone: string): boolean {
  try {
    Intl.DateTimeFormat("en-US", { timeZone });
    return true;
  } catch {
    return false;
  }
}

function resolveUserTimezone(profileTimeZone?: string | null, browserTimeZone?: string): string {
  const trimmed = profileTimeZone?.trim();
  if (trimmed && isValidIanaTimeZone(trimmed)) {
    return trimmed;
  }

  const browser = browserTimeZone ?? Intl.DateTimeFormat().resolvedOptions().timeZone;
  return isValidIanaTimeZone(browser) ? browser : "UTC";
}

export default function useUserTimezone(): string {
  const { user } = useCurrentUser();

  return useMemo(() => resolveUserTimezone(user.timezone), [user.timezone]);
}
